export class LegacyV31Adapter {
  constructor({ mount, input = null }) {
    this.mount = mount;
    this.input = input;
    this.frame = null;
    this.detachInputSource = null;
    this.ready = false;
  }

  launch() {
    if (!this.frame) {
      this.frame = document.createElement('iframe');
      this.frame.className = 'legacy-frame';
      this.frame.title = 'SERPENT v31 compatibility baseline';
      this.frame.allow = 'fullscreen; gamepad; autoplay';
      this.frame.src = '/legacy/v31/index.html';
      this.mount.replaceChildren(this.frame);
      this.frame.addEventListener('load', () => {
        this.ready = true;
        this.#attachInputSource();
        this.focus();
      }, { once: true });
    }
    this.focus();
  }

  focus() {
    this.frame?.focus();
    this.frame?.contentWindow?.focus();
  }

  forwardInput(snapshot) {
    if (!this.ready || !this.frame?.contentWindow) return;
    try {
      this.frame.contentWindow.postMessage({
        type: 'SERPENT_INPUT_FRAME',
        version: 1,
        snapshot,
      }, window.location.origin);
    } catch {
      // The compatibility runtime continues using its native input listeners.
    }
  }

  destroy() {
    this.detachInputSource?.();
    this.detachInputSource = null;
    this.frame?.remove();
    this.frame = null;
    this.ready = false;
  }

  #attachInputSource() {
    this.detachInputSource?.();
    try {
      this.detachInputSource = this.input?.attach({
        windowRef: this.frame.contentWindow,
        documentRef: this.frame.contentDocument,
      }) || null;
    } catch {
      this.detachInputSource = null;
    }
  }
}
